import { useState, useEffect } from "react";
import { collection, query, where, or, onSnapshot } from "firebase/firestore";
import { clienteDb } from "../utils/clienteAuth";
import { fmtMoeda } from "../utils/format";
import { ChatPedido } from "./ChatPedido";
import { pedidoOnlineOculto } from "../constants/statusPedido";

const STATUS_LABEL = {
  pagamento_em_analise: { txt: "Conferindo pagamento", cor: "#f59e0b" },
  pago: { txt: "Pagamento confirmado", cor: "#22c55e" },
  imprimindo: { txt: "Imprimindo 🖨️", cor: "#3b82f6" },
  pronto: { txt: "Pronto 📦", cor: "#f0a830" },
  em_entrega: { txt: "Saiu para entrega 🛵", cor: "#0ea5e9" },
  concluido: { txt: "Concluído", cor: "#22c55e" },
  cancelado: { txt: "Cancelado", cor: "#ef4444" }
};

export function MeusPedidos({ vendedorId, cliente }) {
  const [pedidos, setPedidos] = useState([]);
  const [aberto, setAberto] = useState(null);
  const [carregando,setCarregando] = useState(true);
  const [erro,setErro] = useState(false);
  const [tentativa,setTentativa] = useState(0);
  const authUid = cliente?.authUid || cliente?.uid;

  useEffect(() => {
    if (!vendedorId || !authUid) return;
    setCarregando(true); setErro(false); setPedidos([]); setAberto(null);
    const q = query(
      collection(clienteDb, `users/${vendedorId}/pedidos_online`),
      or(where("cliente.uid", "==", authUid),where("cliente.authUid", "==", authUid))
    );
    const unsub = onSnapshot(q, (snap) => {
      // Pagamento pelo Mercado Pago que não foi concluído não vira pedido
      const lista = snap.docs.map(d => ({ id: d.id, ...d.data() })).filter(p => !pedidoOnlineOculto(p));
      lista.sort((a, b) => (b.ts || 0) - (a.ts || 0));
      setPedidos(lista);
      setCarregando(false);
    }, () => { setCarregando(false); setErro(true); });
    return () => unsub();
  }, [vendedorId, authUid, tentativa]);

  if (aberto) {
    return (
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <button onClick={() => setAberto(null)} style={{
          background: "none", border: "none", color: "#00d4aa", cursor: "pointer",
          fontSize: 13, marginBottom: 12, alignSelf: "flex-start"
        }}>← Voltar aos pedidos</button>
        <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 10 }}>
          Pedido #{aberto.id.slice(-5)} · {fmtMoeda(aberto.total)}
        </div>
        <div style={{ flex: 1, minHeight: 0 }}>
          <ChatPedido vendedorId={vendedorId} pedidoId={aberto.id} autor="cliente" altura={320} />
        </div>
      </div>
    );
  }

  return (
    <div>
      <h3 style={{ margin: "0 0 16px", fontSize: 16 }}>📦 Meus Pedidos</h3>
      {carregando ? <p role="status" style={{color:"#a6bfd1",fontSize:13}}>Carregando seus pedidos…</p> : erro ? <div role="alert" style={{color:"#f3bead",fontSize:13,lineHeight:1.6}}>Não foi possível carregar seus pedidos.<button type="button" onClick={()=>setTentativa(v=>v+1)} style={{display:"block",minHeight:44,marginTop:10,background:"#173b49",color:"#a0e4d5",border:"1px solid #356674",borderRadius:10,padding:"8px 12px",cursor:"pointer"}}>Tentar novamente</button></div> : pedidos.length === 0 ? (
        <div style={{ color: "#64748b", fontSize: 13, textAlign: "center", padding: 30 }}>
          Você ainda não fez pedidos.
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {pedidos.map(p => {
            const st = STATUS_LABEL[p.status] || STATUS_LABEL.pagamento_em_analise;
            return (
              <button key={p.id} onClick={() => setAberto(p)} style={{
                textAlign: "left", background: "#142b4a", border: "1px solid rgba(255,255,255,0.08)",
                borderRadius: 12, padding: 14, cursor: "pointer", color: "#f1f5f9"
              }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
                  <strong style={{ fontSize: 13 }}>Pedido #{p.id.slice(-5)}</strong>
                  <span style={{ fontSize: 11, color: st.cor, fontWeight: 700 }}>● {st.txt}</span>
                </div>
                <div style={{ fontSize: 12, color: "#94a3b8" }}>
                  {(p.itens || []).reduce((s, i) => s + (i.qtd || 0), 0)} item(s) · {fmtMoeda(p.total)}
                </div>
                {p.cupom?.codigo && <div style={{fontSize:11,color:"#81dac0",marginTop:6}}>Cupom {p.cupom.codigo} · desconto de {fmtMoeda(p.desconto || 0)}</div>}
                {p.ultimaMsg && (
                  <div style={{ fontSize: 11, color: "#64748b", marginTop: 6, fontStyle: "italic", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {p.ultimaMsgAutor === "vendedor" ? "Vendedor: " : "Você: "}{p.ultimaMsg}
                  </div>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
